var map = {
	"./af/apple.png": 630819,
	"./af/google.png": 492830,
	"./ar/apple.png": 115223,
	"./ar/google.png": 8026,
	"./az/apple.png": 57231,
	"./az/google.png": 295618,
	"./bg/apple.png": 552479,
	"./bg/google.png": 318706,
	"./bn/apple.png": 10550,
	"./bn/google.png": 443129,
	"./bs/apple.png": 427691,
	"./bs/google.png": 142038,
	"./cs/apple.png": 400216,
	"./cs/google.png": 109383,
	"./da/apple.png": 666859,
	"./da/google.png": 358166,
	"./de/apple.png": 951663,
	"./de/google.png": 608802,
	"./el/apple.png": 261881,
	"./el/google.png": 414584,
	"./en-AU/apple.png": 908818,
	"./en-AU/google.png": 414189,
	"./en-GB/apple.png": 404451,
	"./en-GB/google.png": 852510,
	"./en/apple.png": 363591,
	"./en/google.png": 154282,
	"./es-AR/apple.png": 871146,
	"./es-AR/google.png": 268917,
	"./es-ES/apple.png": 101007,
	"./es-ES/google.png": 631234,
	"./es/apple.png": 798970,
	"./es/google.png": 593637,
	"./et/apple.png": 366177,
	"./et/google.png": 772752,
	"./eu/apple.png": 182664,
	"./eu/google.png": 265367,
	"./fi/apple.png": 978569,
	"./fi/google.png": 279464,
	"./fr-CA/apple.png": 726667,
	"./fr-CA/google.png": 56118,
	"./fr/apple.png": 937326,
	"./fr/google.png": 583649,
	"./gl/apple.png": 807071,
	"./gl/google.png": 120818,
	"./he/apple.png": 268107,
	"./he/google.png": 108534,
	"./hi/apple.png": 236567,
	"./hi/google.png": 758106,
	"./hr/apple.png": 776376,
	"./hr/google.png": 682023,
	"./hu/apple.png": 75643,
	"./hu/google.png": 538118,
	"./id/apple.png": 228813,
	"./id/google.png": 634180,
	"./it/apple.png": 322269,
	"./it/google.png": 820020,
	"./ja/apple.png": 442373,
	"./ja/google.png": 92716,
	"./ka/apple.png": 925014,
	"./ka/google.png": 526681,
	"./kk/apple.png": 596408,
	"./kk/google.png": 453415,
	"./km/apple.png": 787242,
	"./km/google.png": 609653,
	"./ko/apple.png": 832660,
	"./ko/google.png": 494619,
	"./lt/apple.png": 351270,
	"./lt/google.png": 51081,
	"./lv/apple.png": 761136,
	"./lv/google.png": 145007,
	"./mk/apple.png": 280826,
	"./mk/google.png": 309925,
	"./ms/apple.png": 150386,
	"./ms/google.png": 61197,
	"./nb/apple.png": 965494,
	"./nb/google.png": 248121,
	"./nl/apple.png": 361908,
	"./nl/google.png": 367867,
	"./pl/apple.png": 178730,
	"./pl/google.png": 608245,
	"./pt-PT/apple.png": 912707,
	"./pt-PT/google.png": 908542,
	"./pt/google.png": 876861,
	"./ro/apple.png": 412791,
	"./ro/google.png": 61434,
	"./ru/apple.png": 227377,
	"./ru/google.png": 116864,
	"./sk/apple.png": 552416,
	"./sk/google.png": 574015,
	"./sl/apple.png": 388131,
	"./sl/google.png": 992670,
	"./sr/apple.png": 235233,
	"./sr/google.png": 918864,
	"./sv/apple.png": 503165,
	"./sv/google.png": 853204,
	"./ta/apple.png": 106619,
	"./ta/google.png": 54150,
	"./te/apple.png": 28543,
	"./te/google.png": 893906,
	"./th/apple.png": 39218,
	"./th/google.png": 806733,
	"./tl/apple.png": 307670,
	"./tl/google.png": 367193,
	"./tr/apple.png": 827172,
	"./tr/google.png": 185931,
	"./uk/apple.png": 955586,
	"./uk/google.png": 991741,
	"./vi/apple.png": 427225,
	"./vi/google.png": 356632,
	"./zh-Hans/apple.png": 252029,
	"./zh-Hans/google.png": 803860,
	"./zh-Hant/apple.png": 602494,
	"./zh-Hant/google.png": 443473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 768355;